// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_os-0";
export var animationContainer = "_os-1";
export var itemPrice = "_os-a";
export var itemizedContent = "_os-9";
export var itemizedHeader = "_os-7";
export var itemizedRow = "_os-8";
export var itemizedSection = "_os-6";
export var modalContent = "_os-2";
export var orderName = "_os-3";
export var refundOption = "_os-4";
export var refundOptionsContainer = "_os-5";
export var shippingLabel = "_os-b";
export var totalRow = "_os-c";